export enum ClaimErrors {
  RECORD_NOT_FOUND = 'record not found',
  CODE_REDEEMED = 'code redeemed',
  LIMIT_REACHED = 'redeeming limit reached',
  RECOVERY_CODE = 'Invalid recovery',
  ALL_CLAIMED = 'total available units: 0',
  TOKEN_GATING_CLAIMED = 'The given gating rule is already processing/completed'
}

export const RPC_URL = {
  1: 'https://eth-mainnet.g.alchemy.com/v2/iB_9SpJ1yj7MtksRPR6aq7cmxzwAwaL-',
  5: 'https://eth-goerli.g.alchemy.com/v2/iB_9SpJ1yj7MtksRPR6aq7cmxzwAwaL-',
  80001: 'https://polygon-mumbai.g.alchemy.com/v2/iB_9SpJ1yj7MtksRPR6aq7cmxzwAwaL-',
  137: 'https://polygon-mainnet.g.alchemy.com/v2/iB_9SpJ1yj7MtksRPR6aq7cmxzwAwaL-'
};

export const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

export enum WalletProviderType {
  METAMASK = 'Metamask',
  WALLET_CONNECT = 'WalletConnect',
  EMAIL = 'Email',
  CROSSMINT = 'Crossmint'
}

export enum AuthTokenType {
  TOKEN = 'Token',
  BEARER = 'Bearer'
}
